import { ANIMAL_SPECIES_ENUM } from "@/features/farm"
import { useGetSpeciesQuery } from "@/features/farm/api/species-api.ts"
import useFarmPermissions from "@/features/permissions/hooks/use-farm-permissions.ts"

const useGetCurrentSpecies = () => {
  const { data: species_breeds } = useGetSpeciesQuery()
  const { permissions } = useFarmPermissions()
  const speciesBreedsArray =
    (species_breeds && Object.values(species_breeds)) || []
  const animalTypesArray: ANIMAL_SPECIES_ENUM[] = []
  if (permissions.cow_module) {
    animalTypesArray.push(ANIMAL_SPECIES_ENUM.COW)
  }
  if (permissions.goat_module) {
    animalTypesArray.push(ANIMAL_SPECIES_ENUM.GOAT)
  }
  if (permissions?.pork_module) {
    animalTypesArray.push(ANIMAL_SPECIES_ENUM.PORK)
  }
  if (permissions?.sheep_module) {
    animalTypesArray.push(ANIMAL_SPECIES_ENUM.SHEEP)
  }

  return animalTypesArray.map((animalType) => {
    return speciesBreedsArray.find((species) => species.name === animalType)
  })
}

export default useGetCurrentSpecies
